import { Divider, Grid, Slider, Typography, useTheme } from '@mui/material';
import React from 'react';
import { sxStyled } from './styles';

const FillterDuration = ({ flightFilters }) => {
  const {
    durationTimeSelected,
    minAndMaxDuration,
    handleChangeDuration,
  } = flightFilters;

  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const [localDuration, setLocalDuration] = React.useState(
    durationTimeSelected
  );

  React.useEffect(() => {
    if (
      localDuration < minAndMaxDuration[0] ||
      localDuration > minAndMaxDuration[1]
    ) {
      setLocalDuration(minAndMaxDuration[1]);
    } else {
      setLocalDuration(durationTimeSelected);
    }
  }, [durationTimeSelected, minAndMaxDuration]);

  return (
    <Grid item lg={12} sm={12} xs={12} sx={sxStyle.filterBox}>
      <Typography
        style={{
          fontSize: '15px',
          color: 'black',
          fontWeight: '600',
        }}
      >
        Duración por tramo
      </Typography>
      <Grid item xs>
        <Slider
          value={localDuration}
          min={minAndMaxDuration[0]}
          max={minAndMaxDuration[1]}
          onChange={(_, value) => setLocalDuration(value)}
          onChangeCommitted={(_, value) => handleChangeDuration(_, value)}
          color={'tertiary'}
          size="small"
        />
        <Typography
          style={{
            fontSize: '14px',
            color: 'black',
          }}
        >
          {`Hasta ${Math.ceil(localDuration / 60)} hs`}
        </Typography>
      </Grid>
      <Divider sx={sxStyle.filterBoxDivider} />
    </Grid>
  );
};

export default FillterDuration;
